// extracted by mini-css-extract-plugin
module.exports = {"UserAgreement":"UserAgreement_UserAgreement__3a9r1","reminder":"UserAgreement_reminder__3Fkph","icon":"UserAgreement_icon__yyrCi","button":"UserAgreement_button__198qS"};